export default __webpack_public_path__ + "static/media/footer-Google-Play.29c1af95.png";